import React, { useState, useEffect } from "react";
import { getLoggedInUser } from "../helpers";
import { Redirect, Link } from 'react-router-dom';
import {
  Container, Card, CardBody, Col, Row, Table, Label, FormGroup, Button, Alert, Input, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { AvForm, AvField, AvGroup, AvInput, AvFeedback } from 'availity-reactstrap-validation';
import ReactTable from "react-table";
import { connect } from "react-redux";
import { betSlipService } from '../redux/betslip/services';
import swal from 'sweetalert';
import Loader from "./Loader/Loader";
import config from 'react-global-configuration';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import addDays from 'date-fns/addDays';
import "react-datepicker/dist/react-datepicker.css";
import styles from "../pages/auth/register.module.css";
import WageringLimit from "../components/WageringLimit";
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "react-i18next";

const DailyLimit = (props) => {
  const [user, setUser] = useState(getLoggedInUser());
  const {t} = useTranslation();
  const [startDate, setStartDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [dailyLimit, setDailyLimit] = useState('');
  const [resMessage, setResMessage] = useState('');
  const [right, setRight] = useState(false);
  const [wrong, setWrong] = useState(false);
  const [userList, setUserList] = useState(null);
  const [depositModalOpen, setDepositModalOpen] = useState(false);

  useEffect(() => {
    loadRecordsTables();
  }, []);

  const loadRecordsTables = () => {
    setIsLoading(true);
    const reqData = {
      'guid': user.guid,
    };

    betSlipService.LimitDetails(reqData).then((res) => {
      setUserList(res[0]);
      setIsLoading(false);
    }).catch((error) => {
      setIsLoading(false);
      // swal(res.message, {
      //     icon: "error",
      // });
    });
  };

  const handleValidSubmit = (event, values) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append('daily_limit', values.daily_limit);
    formData.append('password', values.password);
    formData.append('guid', user.guid);

    betSlipService.updateLimit(formData, config).then((res) => {
      if (res.success) {
        swal({
          title: t('userProfile.limits.titles.success'),
          text: res.message,
          icon: "success",
          buttons: {
            confirm: "Ok"
          },
          successMode: true,
        }).then((result) => {
          if (result) {
            window.location.href = '/user-profile';
          }
        });
      } else {
        swal({
          title: t('userProfile.limits.titles.requiresAttention'),
          text: res.message,
          icon: "info",
          buttons: {
            confirm: "Ok"
          },
          successMode: true,
        });
      }

      setIsLoading(false);
    }).catch((error) => {
      setIsLoading(false);
      // swal(res.message, {
      //     icon: "error",
      // });
    });
  };

  const openDepositModal = () => {
    setDepositModalOpen(true);
  };

  const closeDepositModal = () => {
    setDepositModalOpen(false);
  };

  const onTrigger = (event) => {
    props.parentCallback(true);
  };

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="account-pages">
        <section className="dashboard-section padding-top padding-bottom">
          <Container>
            <Row>
              <Col className="col-lg-12 col-md-12">
                <div className="user-toggler-wrapper d-flex align-items-center d-lg-none">
                  <h4 className="title m-0">Menu</h4>
                  <div className="user-toggler" onClick={onTrigger}>
                    <i className="las la-sliders-h"></i>
                  </div>
                </div>
                <div className="custom--card card--lg">
                  <div className="card--body">
                    <Row>
                      <div className="col-md-12">
                        <Alert color="success" isOpen={right}>
                          {resMessage}
                        </Alert>
                        <Alert color="danger" isOpen={wrong}>
                          {resMessage}
                        </Alert>
                      </div>
                    </Row>
                    <Row className="gy-3 mb-4">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="mb-3">
                           "{t('userProfile.limits.note')}"
                          </label>
                          <h6 id="fname" type="text" name="daily_limit">
                            <span style={{ fontWeight: '100', marginRight: '15px' }}>{t('userProfile.limits.dailyDepositLimit')} : </span>
                            {userList ? userList.daily_limit : ''}
                            <span style={{ fontWeight: '100', marginRight: '40px' }}>{t('userProfile.limits.euro')}</span>
                            <span>
                              <button onClick={openDepositModal} className="cstm_btn2 active mt-3 menu-blnce">{t('userProfile.limits.editLimit')}</button>
                            </span>
                          </h6>
                        </div>
                      </div>
                    </Row>
                    <Modal className="withdraw-request-popup" isOpen={depositModalOpen} toggle={closeDepositModal}>

                     
                      {/* <ModalHeader toggle={closeDepositModal}></ModalHeader> */}
                      <ModalBody>

                         <p onClick={closeDepositModal}>
                        <RxCross2 className="close-btn" />
                      </p>
                        <AvForm onValidSubmit={handleValidSubmit}>
                          <Row className="gy-3">
                            <div className="">
                              <h3 style={{ textAlign: "center" }} className="text-white">{t('userProfile.limits.editDepositLimit')}</h3>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <Label for="code" className="form-label text-white">{t('userProfile.limits.dailyDepositLimit')} <span className="required text-danger">*</span></Label>
                                <AvField id="fname" type="number" className="form-control form--control style-two text-white" name="daily_limit" placeholder={t('userProfile.limits.enterLimit')} required value={userList ? userList.daily_limit : ''} errorMessage={t('userProfile.limits.pleaseEnterLimit')} />
                              </div>
                            </div>
                            <div className="col-md-12 col-sm-12">
                              <div className="form-group">
                                <Label for="code" className="form-label text-white">{t('userProfile.limits.confirmPassword')} <span className="required text-danger">*</span></Label>
                                <AvField id="password" type="password" className="form-control form--control style-two text-white" name="password" placeholder={t('userProfile.limits.enterPassword')} confirmPassword validate={{ required: { value: true, errorMessage: t('userProfile.limits.pleaseEnterPassword') } }} />
                              </div>
                            </div>
                            <div className="col-md-12 col-sm-12 center">
                              <button className="cstm_btn2 active mt-3">Update</button>
                            </div>
                          </Row>
                        </AvForm>
                      </ModalBody>
                    </Modal>
                    <WageringLimit />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.Auth;
  return user;
};

export default connect(mapStateToProps)(DailyLimit);
